import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { CurrencyPipe} from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogWithCloseButtonComponent } from '../../utils/dialog-with-close-button/dialog-with-close-button.component';
import { DataService } from 'src/app/shared/data.service';


@Component({
    selector: 'app-donate',
    templateUrl: './donate.component.html',
    styleUrls: ['./donate.component.scss'],
    standalone: false
})
export class DonateComponent implements OnInit {
  
  buttonSelected: string = "Donate";
  formattedAmount;

  popMsg = {
    'title':'',
    'message':''
  }

  paymentData = {
    amount:'',
    payee:''
  }

  donateForm = this.fb.group({
    amount: ['', Validators.required],
    donarName: ['']
  });  
  
  constructor(
    private fb: UntypedFormBuilder, 
    private currencyPipe : CurrencyPipe, 
    private router: Router, 
    public dialog:MatDialog,
    public dataSvc: DataService) { }


  ngOnInit(): void {
  }

  onSubmit() {
    // TODO: Use EventEmitter with form value
    console.warn(this.donateForm.controls['amount'].value);
    console.warn(this.donateForm.value);
    this.paymentData.amount = this.donateForm.controls['amount'].value;
    this.paymentData.payee = this.donateForm.controls['donarName'].value;
    this.dataSvc.setSharedData(this.paymentData);
    this.router.navigate(['/payment']);

  }  

  transformAmount(element){
    this.formattedAmount = this.currencyPipe.transform(this.formattedAmount, '$');
    element.target.value = this.formattedAmount;
  }

  openDialog(popupMessage){
    this.dialog.open(DialogWithCloseButtonComponent, {data: popupMessage});
  }

  cancel(){
    this.router.navigate(['/reception']);
  }

}
